import { render, staticRenderFns } from "./modalHistorialCambios.vue?vue&type=template&id=576bb2d4&scoped=true"
import script from "./modalHistorialCambios.vue?vue&type=script&lang=js"
export * from "./modalHistorialCambios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576bb2d4",
  null
  
)

export default component.exports